import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

// Atom to store internet status
export const isOnlineAtom = atom<boolean>(
  typeof window !== 'undefined' ? window.navigator.onLine : true
);

/**
 * Hook to initialize internet connectivity monitoring.
 * Should be used in a global layout or component.
 */
export function useInternetConnectivity() {
  const [isOnline, setIsOnline] = useAtom(isOnlineAtom);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    setIsOnline(window.navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setIsOnline]);

  return isOnline;
}
